export function relativeTime(date, shortened = false) {
    const difference = new Date() - date;

    const seconds = Math.floor(difference / 1000); 
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);

    switch (true) {
        case (days > 0):
            if (shortened) {
                return `${days}d geleden`;
            } else {
                return `${days} dag${days === 1 ? '' : 'en'} geleden`;
            }
        case (hours > 0):
            if (shortened) {
                return `${hours}u geleden`;
            } else {
                return `${hours} uur${hours === 1 ? '' : 'en'} geleden`;
            }
        case (minutes > 0):
            if (shortened) {
                return `${minutes}m geleden`;
            } else {
                return `${minutes} minuut${minutes === 1 ? '' : 'en'} geleden`;
            }
        default:
            if (shortened) {
                return `Zojuist`;
            } else {
                return `${seconds} seconde${seconds === 1 ? '' : 'n'} geleden`;
            }
    }
}
